import React, { useState } from 'react';

const itServicesTabsData = [
  {
    id: 'software-dev',
    title: 'Software Development',
    contentTitle: 'Software Development',
    intro:
      'Software development is not just writing code, it’s about building the perfect tools that solve real problems. We offer custom software development services that are customized to your needs, whether you are looking for smooth operations, enhancing customer experience, or launching a brand. We take the time to understand your goals, then turn them into secure, scalable, and user friendly software that delivers desired results. From planning and prototyping to development and deployment, our IT professionals are here to provide IT solutions that bring your ideas to life.',
    points: [
      'Custom Software Development',
      'ERP Solutions',
      'API Integration',
      'SaaS Solutions',
      'Database Integration',
      'IT Consulting Expertise',
      'Full Lifecycle Management',
      'Conference Management System',
      'Customer Relationship Management'
    ],
    closing:
      'Our IT consultancy agency manages everything from concept to deployment. We are among the top IT companies in Pakistan, and we are here to present software that adapts and grows to meet your evolving requirements.'
  },
  {
    id: 'cloud-solutions',
    title: 'Cloud Solutions',
    contentTitle: 'Cloud Solutions',
    intro:
      'Cloud Solutions are an important aspect of our IT Services. They help businesses to work smarter, fastly, and securely. Our information technology company offers end to end cloud services to handle all the tasks. We manage migration, infrastructure, and also optimize the ongoing tasks. Our cloud solutions reduce costs and increase accessibility. Our team also improves data security and helps you take full control of cloud technology to scale with confidence and collaborate more efficiently. Our IT services run your systems without interruption. Our cloud solutions include:',
    points: [

      'Cloud Migration Services',
      'Cloud Management and Optimization',
      'Infrastructure as a Service (IaaS)',
      'Platform as a Service (PaaS)',
      'Data Accessibility and Security',
      'Cost Reduction'
    ],
    closing:
      'Migrate, manage, and optimize your infrastructure in the cloud with our IT consultancy services; it reduces costs and increases productivity.'
  },
  {
    id: 'cybersecurity',
    title: 'Cybersecurity',
    contentTitle: 'Cybersecurity',
    intro:
      'Cybersecurity is no longer optional—it’s essential. Being one of the top notch IT companies in Karachi, we offer complete cybersecurity solutions designed to protect your business from ever evolving digital threats. Our IT solutions start from securing your networks and systems to protecting sensitive data, we take a proactive approach to guard against. Our team works closely with you to assess risks, implement strong security protocols, and respond quickly to potential breaches. With our cybersecurity services in place, you can focus on running your business, while we focus on keeping it safe.',
    points: [
      'Comprehensive Risk Assessments',
      'Reliable Security Measures Implementation',
      'Sensitive Data Protection',
      'Cloud Security',
      'Application Security',
      'Disaster Recovery',
      'Malware Protection'
    ],
    closing:
      'With our managed IT services, you’ll get peace of mind knowing your business is safe, while we stay one step ahead of cyber threats, so you can focus on what you do best.'
  },
  {
    id: 'it-outsourcing',
    title: 'IT Outsourcing',
    contentTitle: 'IT Outsourcing',
    intro:
      'With our IT Outsourcing services, we handle everything, so you can finally get the rest and focus your business deserves. At our IT company, we become your dedicated IT team, managing your technical needs from day-to-day support to long-term strategy. Whether it is maintaining your structure, troubleshooting issues, or implementing new solutions, we take full responsibility so you don’t have to stress over the technical stuff. You get reliable, expert IT support without the overhead, while we keep your systems running smoothly behind the scenes.',
    points: [
      'Dedicated Software Development Teams',
      '24/7 Helpdesk & Technical Support Staff',
      'Infrastructure Management & System Administration',
      'IT Project Management & Agile Delivery',
      'Specialized Staff Augmentation',
      'Legacy System Modernization & Maintenance',
      'Network Operations Center (NOC) Support',
      'Cost-Effective Offshore IT Solutions',
      'Team Extension with IT Experts',
      'Cloud Computing',
      'Managed IT Solutions',
      'Cybersecurity',
      'IT Outsourcing',
      'Application Management',
      'Project Outsourcing',
      'IT Support'
    ],
    closing:
      'Hire our leading IT services company to bring innovation to your work and to grow your business.'
  },
  {
    id: 'sqa-deployment',
    title: 'Software Quality Assurance & Deployment',
    contentTitle: 'Software Quality Assurance & Deployment',
    intro:
      'Software Quality Assurance delivers reliable and high performing solutions with our IT services. At our IT company, we make sure every detail is covered so you don’t have to worry. We test every detail of your software to find bugs. Our team provides the best functionality and verifies that everything runs properly. Once your product is ready, we handle the deployment process smoothly by minimizing downtime and ensuring a smooth rollout. From start to final launch, we manage it all. So you can relax knowing your software is secure, stable, and ready to perform.',
    points: [
      'Software Quality Assurance (QA)',
      'Software Deployment Services',
      'Optimal Software Performance',
      'Thorough Testing Processes',
      'Comprehensive Validation Processes',
      'High-Quality Software Releases',
      'Expert QA Services',
      'Expert Deployment Services',
      'Customer Satisfaction Maintenance'
    ],
    closing:
      'We deliver the best software releases at our IT consulting agency. Get our expert QA and deployment services to maintain customer satisfaction.'
  },
  {
    id: 'database-management',
    title: 'Database Management',
    contentTitle: 'Database Management',
    intro:
      'Our Information Technology Company improves your data infrastructure with expert database management. Our database management services present secure data access and enhance the performance of your company. We offer a lot more, some of them are:',
    points: [
      'Expert Database Management',
      'Improved Data Infrastructure',
      'Secure Data Access',
      'Enhanced Company Performance',
      'Information Safeguarding',
      'Efficient Data Storage',
      'Reliable Data Backup',
      'Streamlined Data Recovery'
    ],
    closing:
      'Our IT consultancy services are here to help you. Safeguard your critical information to protect your company. We present efficient data storage, backup, and recovery to ensure seamless working while we handle the rest.'
  },
  {
    id: 'ai-solutions',
    title: 'Artificial Intelligence (AI) Solutions',
    contentTitle: 'Artificial Intelligence (AI) Solutions',
    intro:
      'Artificial Intelligence (AI) Solutions are transforming how businesses operate, and with our IT solutions, we bring that innovation directly to you. At our company, we develop and implement AI-powered solutions that help automate processes, enhance decision-making, and create smarter customer experiences. Whether you’re looking to integrate AI into your existing systems or build custom AI applications from the ground up, we handle the entire process. From data analysis and machine learning models to intelligent automation, our IT managed services do the heavy lifting, so you can stay focused while your business gets smarter.',
    points: [
      'Intelligent AI Solutions',
      'Business Growth and Development',
      'Processes Automation',
      'Technical Insights',
      'Machine Learning Applications',
      'Data Analytics Expertise',
      'Enhanced Customer Experiences'
    ],
    closing:
      'Our IT and BPO company uses machine learning and data analytics to optimize operations and present the best customer experiences.'
  }
];

function ItServicesTabs() {
  const [activeTabId, setActiveTabId] = useState('software-dev');

  const activeService =
    itServicesTabsData.find((item) => item.id === activeTabId) || itServicesTabsData[0];

  return (
    <section className="it-tabs-section">
      <div className="container">
        {/* Section Header: Title on Left, Description on Right */}
        <div className="it-tabs-header-row">
          <div className="it-tabs-header-left">
            <h2 className="it-tabs-main-title">
              Services We Provide at Our IT Company
            </h2>
          </div>
          <div className="it-tabs-header-right">
            <p className="it-tabs-header-desc">
              Here are our IT managed services that we offer to clients at our top rated IT services company.
            </p>
          </div>
        </div>

        {/* Tabs & Content Layout */}
        <div className="it-tabs-main-grid">
          {/* Left Side: Dark Vertical Sidebar Tabs */}
          <div className="it-tabs-sidebar">
            <ul className="it-tabs-list">
              {itServicesTabsData.map((item) => {
                const isActive = item.id === activeTabId;
                return (
                  <li key={item.id} className="it-tab-item">
                    <button
                      className={`it-tab-button ${isActive ? 'active' : ''}`}
                      onClick={() => setActiveTabId(item.id)}
                    >
                      {item.title}
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Right Side: Tab Content Card */}
          <div className="it-tab-content-card">
            <h3 className="it-tab-content-heading">
              {activeService.contentTitle}
            </h3>

            <p className="it-tab-content-intro">
              {activeService.intro}
            </p>

            <ul className="it-tab-bullet-list">
              {activeService.points.map((point, index) => (
                <li key={index} className="it-tab-bullet-item">
                  <span className="it-bullet-dot">•</span>
                  <span className="it-bullet-text">{point}</span>
                </li>
              ))}
            </ul>

            <p className="it-tab-content-closing">
              {activeService.closing}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ItServicesTabs;
